
let DepositSubmitButtonTrait;
export default DepositSubmitButtonTrait = that => {
    const ret = {
        init: () => {
        },
        submitBtnEnable: () => {
            let { setting } = that.props.currDepositDetail;
            let errors = Object.values(that.props.form.getFieldsError()).some((v) => v !== undefined);
            let values = Object.values(that.props.form.getFieldsValue()).some((v) => v == '' || v == undefined);
            if (setting && setting.showDepositorNameField && !setting.prefillRegisteredName) {
                return !values && that.props.form.getFieldValue('money') !== '' && !errors;
            }
            return that.props.form.getFieldValue('money') !== '' && !errors;
        },
    };
    ret.submitBtnDisable = () => !ret.submitBtnEnable();
    return ret;
}
